module.exports = [{
      plugin: require('C:/Users/michi/Documents/GitHub/daudr-photography/node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-45433517-6"},
    },{
      plugin: require('C:/Users/michi/Documents/GitHub/daudr-photography/node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('C:/Users/michi/Documents/GitHub/daudr-photography/node_modules/gatsby-plugin-typography/gatsby-browser.js'),
      options: {"plugins":[],"pathToConfigModule":"src/utils/typography"},
    },{
      plugin: require('C:/Users/michi/Documents/GitHub/daudr-photography/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
